// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_BuscarOrcamentosParaCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /orcamentos/buscar_orcamentos_para_compromisso
 *
 * Returns list of orcamentos available to link to compromissos.
 */
import type { Orcamentos_BuscarOrcamentosParaCompromissoRow } from './Orcamentos_BuscarOrcamentosParaCompromissoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_BuscarOrcamentosParaCompromissoResponseDados = Orcamentos_BuscarOrcamentosParaCompromissoRow[];

export type Orcamentos_BuscarOrcamentosParaCompromissoResponse = ApiResponse<Orcamentos_BuscarOrcamentosParaCompromissoResponseDados>;

registerResponseContract('Orcamentos_BuscarOrcamentosParaCompromissoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      orcamento_id:     { type: 'number',  required: true },
      orcamento_valor:  { type: 'number',  required: true },
      orcamento_status: { type: 'string',  required: true },
      cliente_nome:     { type: 'string',  required: false },
      cliente_id:       { type: 'number',  required: false },
      motivos:          { type: 'array',   required: false },
    },
  },
})
